module.exports = __webpack_public_path__ + "img/1.da573ae3.png";